// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill'
import Vue from 'vue'
import App from './App'
import store from './store'
// import VueCookies from 'vue-cookies'
import './iView'
import './custom'
import './filter'
import './theme/main.less'
import './i18n'
import router from './router'
import 'vue-multiselect/dist/vue-multiselect.min.css'

import PairIcon from './icons'
Vue.use(PairIcon)
// Vue.use(VueCookies)

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: {
    App
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js